<template>
  <div>
    <div
      ref="fotoPortadaRef"
      class="fotoportada-container"
    >
      <!-- 🌿 DECORACIONES EN LAS 4 ESQUINAS (EFECTO DIBUJO CON GSAP) -->
      <!-- Separamos las referencias para controlar la opacidad final individualmente -->
      <img ref="elemTLRef" src="@/assets/esq1.png" class="decor-esquina corner-tl" alt="Decoración Esquina TL" />
      <img ref="florTRRef" src="@/assets/elemento2.png" class="decor-esquina corner-tr" alt="Decoración Esquina TR" />
      <img ref="florBLRef" src="@/assets/elemento2.png" class="decor-esquina corner-bl" alt="Decoración Esquina BL" />
      <img ref="elemBRRef" src="@/assets/esq1.png" class="decor-esquina corner-br" alt="Decoración Esquina BR" />

      <div class="overlay">

        <!-- 👑 CORONA DE ENCABEZADO -->
        <div class="corona-container">
          <img 
            ref="mascaraRef" 
            src="@/assets/coronaa.png" 
            alt="Corona" 
            class="corona-img"
          >
        </div>

        <!-- SECCIÓN CENTRAL: Textos y Nombre -->
        <div class="centered-content">
          <p ref="acompanaRef" class="texto-acompana">IT IS AN HONOR TO INVITE YOU TO THE</p>
          <h2 ref="quinceaneraTitleRef" class="quinceanera-title">QUINCEAÑERA</h2>
          <p ref="deRef" class="texto-de">OF</p>
          <h1 ref="nombreRef" class="nombre-principal">Heidi Singh</h1>
        </div>

        <!-- 📅 BLOQUE DE FECHA (JUSTO DEBAJO DEL NOMBRE) -->
        <div ref="fechaRef" class="fecha-bloque">
          <span class="fecha-mes">SATURDAY</span>
          
          <div class="fecha-linea-central">
            <span class="fecha-dia-texto">DECEMBER</span>
            <div class="linea-divisoria"></div>
            <span class="fecha-dia-numero">26</span>
            <div class="linea-divisoria"></div>
            <span class="fecha-hora-texto">AT 4PM</span>
          </div>

          <span class="fecha-anio">2026</span>
        </div>

        <!-- 🦋 CONTENEDOR DE MARIPOSAS -->
        <div class="butterflies-container">
          <img 
            ref="mariposa1Ref" 
            :src="mariposaImg" 
            alt="Mariposa 1" 
            class="mariposa-img vuelo-suave"
          >
          <img 
            ref="mariposa2Ref" 
            :src="mariposaImg" 
            alt="Mariposa 2" 
            class="mariposa-img vuelo-suave"
          >
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'

// Importar la imagen explícitamente
import mariposaImg from '@/assets/mariposa.png'

export default {
  name: 'InvitacionQuinceanera',
  setup() {
    // Referencias HTML
    const fotoPortadaRef = ref(null)
    const mascaraRef = ref(null)
    const acompanaRef = ref(null)
    const quinceaneraTitleRef = ref(null)
    const deRef = ref(null)
    const nombreRef = ref(null)
    const fechaRef = ref(null)
    
    // Referencias Esquinas Decorativas Individuales
    const elemTLRef = ref(null) // Top Left (elemento3)
    const florTRRef = ref(null) // Top Right (flor)
    const florBLRef = ref(null) // Bottom Left (flor)
    const elemBRRef = ref(null) // Bottom Right (elemento3)

    // Referencias directas a las mariposas
    const mariposa1Ref = ref(null)
    const mariposa2Ref = ref(null)

    onMounted(() => {
      const w = window.innerWidth;
      const h = window.innerHeight;

      // ---------------------------------------------------------
      // 0. ESTADO INICIAL
      // ---------------------------------------------------------
      gsap.set(mascaraRef.value, { opacity: 0, scale: 0.5, y: -20 });

      // Agrupamos las referencias para el clipPath inicial
      const todasLasEsquinas = [elemTLRef.value, florTRRef.value, florBLRef.value, elemBRRef.value];
      
      // Estado inicial para todas (ocultas y sin clipPath)
      gsap.set(todasLasEsquinas, {
        opacity: 0,
        clipPath: 'polygon(0% 0%, 0% 0%, 0% 0%, 0% 0%)'
      });

      // Estado inicial mariposas
      gsap.set(mariposa1Ref.value, { 
        x: w + 200, 
        y: h * 0.8, 
        opacity: 0, 
        scale: 0.7, 
        rotation: -20
      });

      gsap.set(mariposa2Ref.value, { 
        x: -200, 
        y: h * 0.9, 
        opacity: 0, 
        scale: 0.8, 
        rotation: 20
      });

      // ---------------------------------------------------------
      // 1. ANIMACIÓN DE ENTRADA PRINCIPAL
      // ---------------------------------------------------------
      gsap.from(fotoPortadaRef.value, { opacity: 0, y: 50, duration: 1.2, ease: 'power3.out' })
      
      const tl = gsap.timeline({ delay: 0.4 });
      
      // --- CAMBIO CLAVE AQUÍ ---
      // Animamos primero el clipPath para las 4 esquinas simultáneamente (o con un stagger muy pequeño)
      tl.to(todasLasEsquinas, {
        clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
        duration: 1.6,
        ease: 'power2.inOut'
      })
      // Y AHORA animamos la opacidad final por separado con un stagger
      // Usamos una posición relativa para que esta animación comience junto con la del clipPath
      .to([elemTLRef.value, elemBRRef.value], {
        opacity: 0.85, // Opacidad fuerte para 'elemento3'
        duration: 1.6,
        ease: 'power2.inOut'
      }, "<")
      .to([florTRRef.value, florBLRef.value], {
        opacity: 0.25, // <--- AQUÍ DEFINES LA OPACIDAD TENUE PARA LAS FLORES (0.0 a 1.0)
        duration: 1.6,
        ease: 'power2.inOut'
      }, "<") // Empezar al mismo tiempo que la animación anterior
      
      // Continuamos con el resto de la animación
      .to(mascaraRef.value, { opacity: 1, scale: 1, y: 0, duration: 1, ease: 'back.out(1.7)' }, "-=1")
      .from([acompanaRef.value, quinceaneraTitleRef.value, deRef.value], { opacity: 0, y: 25, duration: 0.8, stagger: 0.15, ease: 'power2.out' }, "-=0.4")
      .from(nombreRef.value, { opacity: 0, scale: 0.9, duration: 1.2, ease: 'power3.out' }, "-=0.3")
      .from(fechaRef.value, { opacity: 0, y: 30, duration: 1, ease: 'power3.out' }, "-=0.4");

      // ---------------------------------------------------------
      // 🦋 2. ANIMACIÓN DE MARIPOSAS (sin cambios)
      // ---------------------------------------------------------
      const tlFlight = gsap.timeline({ repeat: -1 });

      // Mariposa 1
      tlFlight.to(mariposa1Ref.value, {
        duration: 5,
        x: w * 0.5,
        y: h * 0.5,
        opacity: 1,
        ease: "sine.inOut"
      }, 0)
      .to(mariposa1Ref.value, {
        duration: 5,
        x: -200,
        y: h * 0.1,
        opacity: 0,
        ease: "sine.inOut"
      })
      .set(mariposa1Ref.value, {
        x: w + 200,
        y: h * 0.8,
        opacity: 0,
        scale: 0.7,
        rotation: -20
      });

      // Mariposa 2
      tlFlight.to(mariposa2Ref.value, {
        duration: 5,
        x: w * 0.5,
        y: h * 0.5,
        opacity: 1,
        ease: "sine.inOut"
      }, 5)
      .to(mariposa2Ref.value, {
        duration: 5,
        x: w + 200,
        y: h * 0.2,
        opacity: 0,
        ease: "sine.inOut"
      })
      .set(mariposa2Ref.value, {
        x: -200,
        y: h * 0.9,
        opacity: 0,
        scale: 0.8,
        rotation: 20
      });
    })

    return {
      fotoPortadaRef, mascaraRef, acompanaRef, quinceaneraTitleRef,
      deRef, nombreRef, fechaRef, mariposa1Ref, mariposa2Ref,
      elemTLRef, florTRRef, florBLRef, elemBRRef,
      mariposaImg
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;600;700&family=Great+Vibes&display=swap');

/* ==========================================
   1. CONTENEDOR GENERAL CON FONDO BORGOÑA
   ========================================== */
.fotoportada-container {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background: radial-gradient(circle at center, #6d0a14 0%, #3e0409 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;  margin-bottom:-65px;

  overflow: hidden;
  padding: 40px 15px;
  box-sizing: border-box;
}

/* ==========================================
   🌿 DECORACIÓN EN LAS 4 ESQUINAS
   ========================================== */
.decor-esquina {
  position: absolute;
  width: clamp(110px, 30vw, 120px) !important;
  height: auto;
  pointer-events: none;
  z-index: 3;
  /* Eliminamos la opacidad de aquí ya que la controla GSAP */
}

.corner-tl {
  top: -10px;
  left: -10px;
}

.corner-tr {
  top: -10px;
  right: -50px;
  transform: scaleX(-1);
  /* opacity: 0.4; <-- ELIMINADO */
}

.corner-bl {
  bottom: -10px;
  left: -10px;
  transform: scaleY(-1);
}

.corner-br {
  bottom: -10px;
  right: -10px;
  transform: scale(-1, -1);
}

.overlay {
  position: relative;
  width: 100%;
  max-width: 480px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

/* ==========================================
   2. CORONA EN PARTE SUPERIOR
   ========================================== */
.corona-container {
  margin-bottom: 20px;
}

.corona-img {
  width: clamp(100px, 30vw, 140px);
  height: auto;
  filter: drop-shadow(0px 4px 10px rgba(0, 0, 0, 0.4));
}

/* ==========================================
   3. TEXTOS EDITORIALES Y NOMBRE
   ========================================== */
.centered-content {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.texto-acompana {
  font-family: 'Cinzel', serif;
  font-size: clamp(0.75rem, 3vw, 0.95rem);
  font-weight: 600;
  letter-spacing: 0.25em;
  color: #B28F60  ;
  margin-bottom: 6px;
  text-transform: uppercase;
}

.quinceanera-title {
  font-family: 'Cinzel', serif;
  font-size: clamp(1.8rem, 8vw, 2.6rem);
  font-weight: 700;
  letter-spacing: 0.18em;
  color: #B28F60;
  margin: 0;
  line-height: 1.1;
  text-transform: uppercase;
}

.texto-de {
  font-family: 'Cinzel', serif;
  font-size: clamp(0.7rem, 2.5vw, 0.85rem);
  font-weight: 400;
  letter-spacing: 0.3em;
  color: #B28F60;
  margin: 6px 0;
  text-transform: uppercase;
}

.nombre-principal {
  font-family: 'Great Vibes', 'ludovica', cursive;
  font-size: clamp(3.2rem, 14vw, 4.8rem);
  font-weight: 400;
  line-height: 1.1;
  color: #B28F60;
  margin: 0 0 30px 0;
  text-shadow: 0 4px 15px rgba(0, 0, 0, 0.5);
}

/* ==========================================
   4. BLOQUE DE FECHA
   ========================================== */
.fecha-bloque {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 10px;
}

.fecha-mes {
  font-family: 'Cinzel', serif;
  font-size: clamp(0.85rem, 3.5vw, 1.1rem);
  font-weight: 600;
  letter-spacing: 0.35em;
  color: #ffffff;
  margin-bottom: 8px;
}

.fecha-linea-central {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 12px;
}

.linea-divisoria {
  flex: 1;
  height: 1px;
  background-color: #ffffff;
  opacity: 0.85;
}

.fecha-dia-texto,
.fecha-hora-texto {
  font-family: 'Cinzel', serif;
  font-size: clamp(0.75rem, 3vw, 0.95rem);
  font-weight: 600;
  letter-spacing: 0.2em;
  color: #ffffff;
  white-space: nowrap;
}

.fecha-dia-numero {
  font-family: 'Cinzel', serif;
  font-size: clamp(2.8rem, 12vw, 4rem);
  font-weight: 600;
  color: #ffffff;
  line-height: 1;
  padding: 0 6px;
}

.fecha-anio {
  font-family: 'Cinzel', serif;
  font-size: clamp(0.9rem, 4vw, 1.2rem);
  font-weight: 600;
  letter-spacing: 0.4em;
  color: #ffffff;
  margin-top: 8px;
  text-indent: 0.4em;
}

/* ==========================================
   5. 🦋 MARIPOSAS
   ========================================== */
.butterflies-container {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 10;
  overflow: hidden;
}

.mariposa-img {
  position: absolute;
  width: clamp(70px, 22vw, 110px) !important;
  height: auto;
  will-change: transform;
}

@keyframes vueloSuave {
  0%, 100% { transform: translateY(0px) scaleX(1); }
  50% { transform: translateY(-4px) scaleX(0.75); }
}

.vuelo-suave {
  animation: vueloSuave 0.6s infinite ease-in-out;
}
</style>